import api from "../utils/interceptors";

export async function getCollections() {
  const query = `{
  collections(first: 100) {
    edges {
      node {
        id
        title
        image {
          url
        }
        mobileBanner: metafield(namespace: "custom", key: "mobile_banner") {
          reference {
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
      }
    }
  }
}
`;

  try {
    const response = await api.post("", {
      query,
    });

    if (response.data.errors) {
      const errorMessages = response.data.errors
        .map((error) => error.message)
        .join(", ");
      throw new Error(`GraphQL error(s): ${errorMessages}`);
    }

    const collectionsData = response.data.data?.collections;
    if (!collectionsData) {
      throw new Error("No collections data found");
    }
    const collections = collectionsData.edges.map(el => {
      const mobileImage = el.node.mobileBanner?.reference?.image?.url || null;
      return { 
        title: el.node.title, 
        id: el.node.id, 
        imageSrc: el.node.image?.url,
        mobileImageSrc: mobileImage
      };
    });
    return collections;
  } catch (error) {
    console.error("Could not fetch collections:", error.message);
    throw error;
  }
}

export async function getCollectionById(collectionId) {
  const formattedId = collectionId.includes("gid://") ? collectionId : `gid://shopify/Collection/${collectionId}`;
  const query = `{
  collection(id: "${formattedId}") {
    descriptionHtml
    title
    products(first: 100) {
      edges {
        node {
          id
          title
          handle
          metafield(namespace: "custom", key: "stock_quantity") {
            value
          }
          variants(first: 20) {
            edges {
              node {
                title
                image {
                  url
                }
                price {
                  amount
                  currencyCode
                }
                id
              }
            }
          }
        }
      }
    }
  }
}`;

  const variables = { id: collectionId };

  try {
    const response = await api.post("", {
      query,
    });

    if (response.data.errors) {
      const errorMessages = response.data.errors
        .map((error) => error.message)
        .join(", ");
      throw new Error(`GraphQL error(s): ${errorMessages}`);
    }

    const collectionData = response.data.data?.collection;
    if (!collectionData) {
      throw new Error("No collection data found");
    }

    const collectionDetail = {
      title: collectionData.title,
      descriptionHtml: collectionData.descriptionHtml,
    };
    console.log(collectionData.products.edges);
    const products = collectionData.products.edges.map((product) => ({
      title: product.node.title,
      handle: product.node.handle,
      imageSrc: product.node.variants.edges[0].node.image?.url,
      price: product.node.variants.edges[0].node.price.amount,
      productId: product.node.id,
      variantId: product.node.variants.edges[0].node.id,
      variants: product.node.variants.edges.map(v => ({
        id: v.node.id,
        title: v.node.title,
        price: v.node.price.amount
      })),
      stockLeft: product.node.metafield?.value ?? undefined,
    }));

    return { collectionDetail, products };
  } catch (error) {
    console.error("Could not fetch collection items:", error.message);
    throw error;
  }
}